import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Tooltip,
  TableCell,
  Box,
  Typography,
  Grid,
  Chip,
  Paper,
  Divider,
  Button,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { styled } from "@mui/material/styles";
import InfoIcon from "./../../assets/images/icons/info.png";
import { toPascalCase } from "../../utils/formatting";
import { formatDate } from "../../utils/dateFormatUtils";

interface ConfirmDialogProps {
  data: any;
}

const StyledTableCellHead = styled(TableCell)(() => ({
  padding: "8px",
  color: "#168794",
  fontSize: "13px",
  fontWeight: 600,
  fontFamily: "Jost",
  textAlign: "left",
  background: "#fafafa",
}));

const StyledTableCellBody = styled(TableCell)(() => ({
  padding: "8px",
  color: "#707579",
  fontSize: "13px",
  fontWeight: 500,
  lineHeight: "20px",
  textAlign: "left",
}));

// Status pill (chip) design
const StatusChip = styled(Chip)<{ statuscolor?: string; bgcolor?: string }>(
  ({ statuscolor, bgcolor }) => ({
    color: statuscolor || "#EA5455",
    backgroundColor: bgcolor || "rgba(234, 84, 85, 0.2)",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: 500,
    padding: "0 8px",
    height: "24px",
    "& .MuiChip-label": {
      padding: 0,
    },
  })
);
const StatusBadge = styled("span")<{
  statusColor: string;
  backgroundColor: string;
}>(({ statusColor, backgroundColor }) => ({
  color: statusColor,
  textTransform: "capitalize",
  backgroundColor,
  textAlign: "left",
  width: "110px",
  padding: "4px 1px",
  borderRadius: "4px",
  fontSize: "14px",
  fontWeight: 500,
  border: "none",
  display: "inline-block",
}));
const CardDisbursement = (props: ConfirmDialogProps) => {
  const { data } = props;

  return (
    <Card
      sx={{
        borderRadius: "8px",
        border: "1px solid #d0e0e5",
        boxShadow: "0px 0px 6px rgba(22, 135, 148, 0.25)",
        mt: 2,
        backgroundColor: "#fff",
        p: 2,
      }}
    >
      <Grid container spacing={2}>
        {/* Left info box */}
        <Grid item xs={12} sm={3}>
          <Box
            sx={{
              border: "1px solid #d0e0e5",
              borderRadius: "8px",
              boxShadow: "0px 0px 4px rgba(22, 135, 148, 0.15)",
              backgroundColor: "#f9f9f9",
              p: 2,
              height: "100%",
              fontSize: "13px",
            }}
          >
            <Typography variant="body2" fontWeight={350}>
              Request ID
            </Typography>
            <Typography variant="subtitle2" fontWeight={600}>
              {data?.referenceNumber}
            </Typography>

            <Typography variant="body2" fontWeight={350} mt={1}>
              Disbursement Amount
            </Typography>
            <Typography variant="subtitle2" fontWeight={600}>
              INR {data?.disbursedAmount}
            </Typography>

            <Typography variant="body2" fontWeight={350} mt={1}>
              Disbursement Type
            </Typography>
            <Typography variant="subtitle2" fontWeight={600}>
              {data?.lienValues
                ?.map((row: any) => `${toPascalCase(row.type)}`)
                .join(" + ")}
            </Typography>
          </Box>
        </Grid>

        {/* Right table */}
        <Grid item xs={12} sm={9}>
          <Box
            sx={{
              border: "1px solid #d0e0e5",
              borderRadius: "8px",
              boxShadow: "0px 0px 4px rgba(22, 135, 148, 0.15)",
            }}
          >
            {/* <Table size="small">
              <TableHead>
                <TableRow>
                  <StyledTableCellHead>Disbursement Type</StyledTableCellHead>
                  <StyledTableCellHead>Amount</StyledTableCellHead>
                  <StyledTableCellHead>Status</StyledTableCellHead>
                  <StyledTableCellHead>Disbursement Date</StyledTableCellHead>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.lienValues?.map((row: any, index: number) => (
                  <TableRow key={index}>
                    <StyledTableCellBody>{row.type=="lien"?"Fund Release from Lien A/c":row?.type=="tranche"?"New Tranche":""}</StyledTableCellBody>
                    <StyledTableCellBody>{row.amount}</StyledTableCellBody>
                    <StyledTableCellBody>
                      <StatusBadge
                        statusColor="#EA5455"
                        backgroundColor={(data?.status === "Approved" ||  row.status === "Approved" || row?.status==="approve" ||data?.status === "approve")
                            ? "#b4ffd5"
                            : row?.status?.toLowerCase()==="pending" ||data?.status?.toLowerCase() === "pending" || row?.status?.toLowerCase() === "reject" || data?.status?.toLowerCase() === "reject"
                            ? "rgba(234, 84, 85, 0.2)"
                            :data?.status === "query"
                            ? "#eaeaea"
                            : "rgba(8, 7, 7, 0.2)"
                        }
                      >
                        <span
                          style={{
                        color: (data?.status === "Approved" ||  row.status === "Approved" || row?.status==="approve"||data?.status === "approve")
                            ? "#28C76F"
                            : row?.status?.toLowerCase() === "pending" || data?.status?.toLowerCase()==="pending"
                            ? "#EA5455"
                            :data?.status === "query"
                            ? "rgb(28, 177, 177)"
                            : "#EA5455",
                            textTransform: "capitalize",
                            marginLeft: "8px",
                          }}
                        >
                          {row.type==="tranche"?data?.status: row.status}
                          </span>
                          {row?.status?.toLowerCase()=="pending" || (row.type==="tranche" && data?.status?.toLowerCase()==="pending") && 
                          <Tooltip title={row?.BankUploadStatus ?row?.BankUploadStatus:"Pending From Avanse"} enterTouchDelay={50} placement="top">
                            <img
                              src={InfoIcon}
                              alt="Status"
                              style={{
                                height: "15px",
                                width: "15px",
                                position: "relative",
                                left: "45%",
                              }}
                            />
                          </Tooltip>}
                          {row?.status?.toLowerCase()=="pending" && row.type==="lien" && 
                            <Tooltip title={row?.BankUploadStatus ?row?.BankUploadStatus:"Pending From Avanse"} enterTouchDelay={50} placement="top">
                              <img
                                src={InfoIcon}
                                alt="Status"
                                style={{
                                  height: "15px",
                                  width: "15px",
                                  position: "relative",
                                  left: "55%",
                                }}
                              />
                            </Tooltip>}
                          {row.type==="lien" && ((row?.status?.toLowerCase()=="reject" || row?.status?.toLowerCase()=="rejected") && typeof row?.remark === "string" && row?.remark.trim() !== "")
                            &&
                          <Tooltip
                            title={row?.remark}
                            enterTouchDelay={50}
                            placement="top"
                          >
                            <img
                              src={InfoIcon}
                              alt="Status"
                              style={{
                                height: "15px",
                                width: "15px",
                                position: "relative",
                                left: "64%",
                              }}
                            />
                          </Tooltip>
                         }
                         {
                          (row.type==="tranche" && data?.status?.toLowerCase()==="reject") &&
                         
                          <Tooltip
                            title={data?.remark}
                            enterTouchDelay={50}
                            placement="top"
                          >
                            <img
                              src={InfoIcon}
                              alt="Status"
                              style={{
                                height: "15px",
                                width: "15px",
                                position: "relative",
                                left: "64%",
                              }}
                            />
                          </Tooltip>
                         }
                      </StatusBadge>
                    </StyledTableCellBody>
                    <StyledTableCellBody>{formatDate(data?.disbursemntDate)}</StyledTableCellBody>
                  </TableRow>
                ))}
              </TableBody>
            </Table> */}

            <Box>
              {data &&
                data?.lienValues &&
                data?.lienValues?.map((row: any, index: any) => (
                  <>
                    {/* Header Row */}
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      mb={1}
                      padding={"8px"}
                      sx={{
                        color: "text.secondary",
                        fontSize: "0.8rem",
                        paddingBottom: "0px",
                      }}
                    >
                      <Typography
                        flex={1}
                        sx={{ color: "text.secondary", fontSize: "0.8rem" }}
                      >
                        Disbursement Type
                      </Typography>
                      <Typography
                        flex={1}
                        sx={{ color: "text.secondary", fontSize: "0.8rem" }}
                      >
                        Amount
                      </Typography>
                      <Typography
                        flex={1}
                        sx={{ color: "text.secondary", fontSize: "0.8rem" }}
                      >
                        Status
                      </Typography>
                      <Typography
                        flex={1}
                        sx={{ color: "text.secondary", fontSize: "0.8rem" }}
                      >
                        Disbursement Date
                      </Typography>
                    </Box>
                    {/* Data Row */}
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mt={1}
                      padding={"8px"}
                      paddingTop={"0px"}
                      fontSize={"13px"}
                    >
                      <Typography flex={1} fontWeight="500" fontSize={{ xs: 14, sm: 14 }}>
                        {row.type == "lien"
                          ? "Fund Release from Lien A/c"
                          : row?.type == "tranche"
                          ? "New Tranche"
                          : ""}
                      </Typography>
                      <Typography flex={1} fontWeight="500" fontSize={{ xs: 14, sm: 14 }}>
                        INR {row.amount}
                      </Typography>
                      <Box flex={1}>
                        <StatusBadge
                          statusColor="#EA5455"
                          backgroundColor={
                            row?.status === "approved" 
                              ? "#b4ffd5"
                              : row?.status?.toLowerCase() === "pending" ||
                                row?.status?.toLowerCase() === "rejected"
                              ? "rgba(234, 84, 85, 0.2)"
                              : data?.status === "query"
                              ? "#eaeaea"
                              : "rgba(8, 7, 7, 0.2)"
                          }
                        >
                          <span
                            style={{
                              color:
                                row?.status === "approved" 
                                  ? "#28C76F"
                                  : row?.status?.toLowerCase() === "pending"
                                  ? "#EA5455"
                                  : data?.status === "query"
                                  ? "rgb(28, 177, 177)"
                                  : "#EA5455",
                              textTransform: "capitalize",
                              marginLeft: "8px",
                            }}
                          >
                            { row?.status}
                          </span>
                          {row?.status?.toLowerCase() == "pending"  && (
                                <Tooltip
                                  title={
                                    row?.BankUploadStatus
                                      ? row?.BankUploadStatus
                                      : "Pending From Avanse"
                                  }
                                  enterTouchDelay={50}
                                  placement="top"
                                >
                                  <img
                                    src={InfoIcon}
                                    alt="Status"
                                    style={{
                                      height: "15px",
                                      width: "15px",
                                      position: "relative",
                                      left: "56%",
                                    }}
                                  />
                                </Tooltip>
                              )}
                          {row.type === "lien" &&
                            (row?.status?.toLowerCase() == "rejected") &&
                            row?.remark?.length > 0 && (row?.remark?.filter((rem: any) => rem?.remark != data?.remark && data?.remark != "")[0]?.remark || row?.remark?.length == 1) && (
                              <Tooltip
                                title={row?.remark?.length == 1 ? data?.remark : row?.remark?.filter((rem: any) => rem?.remark != data?.remark && data?.remark != "")[0]?.remark}
                                enterTouchDelay={50}
                                placement="top"
                              >
                                <img
                                  src={InfoIcon}
                                  alt="Status"
                                  style={{
                                    height: "15px",
                                    width: "15px",
                                    position: "relative",
                                    left: "64%",
                                  }}
                                />
                              </Tooltip>
                            )}
                          {row.type === "tranche" &&
                            (row?.status?.toLowerCase() === "rejected") && (
                              <Tooltip
                                title={data?.remark}
                                enterTouchDelay={50}
                                placement="top"
                              >
                                <img
                                  src={InfoIcon}
                                  alt="Status"
                                  style={{
                                    height: "15px",
                                    width: "15px",
                                    position: "relative",
                                    left: "56%",
                                  }}
                                />
                              </Tooltip>
                            )}
                        </StatusBadge>
                      </Box>
                      <Typography flex={1} fontWeight="500" fontSize={{ xs: 14, sm: 14 }}>
                        {row?.disbDate ? formatDate(row?.disbDate) : ""}
                      </Typography>
                    </Box>
                    <Divider />
                  </>
                ))}
            </Box>
          </Box>

          {/* Final amount */}
          <Box mt={2}>
            <Typography
              variant="subtitle2"
              fontSize={{ xs: 14, sm: 14 }}
              fontWeight={600}
            >
                   Final Disbursed Amount: 

                      {data?.lienValues
                      ?.filter((item: any) => item.status === "approved")
                      .reduce((sum: any, item: any) => sum + Number(item.amount), 0) === 0
                      ? " NA"
                      : ` INR ${
                        data?.lienValues
                          ?.filter((item: any) => item.status === "approved")
                          .reduce((sum: any, item: any) => sum + Number(item.amount), 0)
                        }`
                      }
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
};

export default CardDisbursement;
